export default __webpack_public_path__ + "static/media/logoGiga.f60402a7.png";